import React, { useState, useEffect } from 'react';
import ManageProductImage from './ManageProductImage';
import ManageProduct from './ManageProduct';
import ManageProductLaunch from './ManageProductLaunch';
import './productImage.css';

const ManageProductWrapper = () => {
	// Initialize tab state from localStorage or default to 'manageProduct'
	const [tab, setTab] = useState(() => {
		return localStorage.getItem('manageProductTab') || 'manageProduct';
	});

	// Save tab state to localStorage whenever it changes
	useEffect(() => {
		localStorage.setItem('manageProductTab', tab);
	}, [tab]);

	function changeTab(newTab) {
		setTab(newTab);
	}

	return (
		<>
			<div className="manage-product-header">
				<div className={`${tab === 'manageProduct' && 'selected'}`} onClick={() => changeTab('manageProduct')}>
					Activate discounts
				</div>
				<div
					className={`${tab === 'manageProductImage' && 'selected'}`}
					onClick={() => changeTab('manageProductImage')}
				>
					Product Image
				</div>
				<div
					className={`${tab === 'manageProductLaunch' && 'selected'}`}
					onClick={() => changeTab('manageProductLaunch')}
				>
					New Product Launch
				</div>
			</div>
			{tab === 'manageProductImage' ? (
				<ManageProductImage />
			) : tab === 'manageProductLaunch' ? (
				<ManageProductLaunch />
			) : (
				<ManageProduct />
			)}
		</>
	);
};

export default ManageProductWrapper;
